import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardDarkProps {
  name: string;
  role: string;
  content: string;
  imageInitial: string;
  color?: string;
}
export function TestimonialCardDark({
  name,
  role,
  content,
  imageInitial,
  color = 'bg-emerald-500'
}: TestimonialCardDarkProps) {
  return <div className="bg-slate-900 p-6 rounded-xl border border-slate-800 flex flex-col h-full hover:border-emerald-500/30 transition-colors" data-id="element-46">
      <div className="flex items-center gap-1 mb-4" data-id="element-47">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-48" />)}
      </div>
      <p className="text-slate-300 italic mb-6 flex-grow leading-relaxed" data-id="element-49">
        "{content}"
      </p>
      <div className="flex items-center gap-3 mt-auto" data-id="element-50">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold ${color}`} data-id="element-51">
          {imageInitial}
        </div>
        <div data-id="element-52">
          <p className="font-bold text-white text-sm" data-id="element-53">{name}</p>
          <p className="text-xs text-slate-500" data-id="element-54">{role}</p>
        </div>
      </div>
    </div>;
}